import { render, staticRenderFns } from "./DeptCourseInfo.vue?vue&type=template&id=6fbe3e95&scoped=true"
import script from "./DeptCourseInfo.vue?vue&type=script&lang=js"
export * from "./DeptCourseInfo.vue?vue&type=script&lang=js"
import style0 from "./DeptCourseInfo.vue?vue&type=style&index=0&id=6fbe3e95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbe3e95",
  null
  
)

export default component.exports